import { useCallback } from 'react';
import { get, find, isArray, isEmpty } from 'lodash';
import { findDocumentsMetadata } from './_api';
import { IPatientDocument } from '../Patient/_types';
import { IUseGridExtendedInfo } from './_types';
import { setColumnsInDocumentGridWithAdditionalInfoBeingLoaded } from 'store/reducers/appReducer';
import { useAppDispatch } from 'store/hooks';

const extendedColumnsSettings = [
  { name: 'externalWorkplaceCode' },
  { name: 'externalWorkplaceName' },
];

export const useGridExtendedInfo = ({ rows, setRows, masterPatientID }: IUseGridExtendedInfo) => {
  const dispatch = useAppDispatch();

  const getExtendedColumns = useCallback((columns: any) => {
    let extendedColumns: string[] = [];
    columns.forEach((column: any) => {
      const extendedColumnSettings = find(extendedColumnsSettings, { name: column.field });
      if (extendedColumnSettings) {
        extendedColumns.push(extendedColumnSettings.name);
      }
    });
    return extendedColumns;
  }, []);

  const saveExtendedInfo = useCallback(
    (data: any) => {
      setRows((rows: IPatientDocument[]) => {
        const extRows = [
          ...rows.map((row: IPatientDocument) => {
            const findPatient = find(
              isArray(data) ? data : [],
              (patient) =>
                get(row, 'uuid') === get(patient, 'uuid') &&
                get(row, 'typeOfDocument.name') === get(patient, 'typeOfDocument.name'),
            );
            return {
              ...row,
              externalWorkplaceCode: get(findPatient, 'externalWorkplaceCode', ''),
              externalWorkplaceName: get(findPatient, 'externalWorkplaceName', ''),
            };
          }),
        ];

        return extRows;
      });
    },
    [setRows],
  );

  const loadExtendedInfo = useCallback(
    async (cols: any) => {
      const extendedColumns = getExtendedColumns(cols);
      const documentIdentity = rows.map((row: IPatientDocument) => ({
        masterPatientID,
        uuid: get(row, 'uuid', ''),
        typeOfDocument: get(row, 'typeOfDocument.name', ''),
      }));
      dispatch(setColumnsInDocumentGridWithAdditionalInfoBeingLoaded(extendedColumns));
      if (!isEmpty(extendedColumns)) {
        const resp = await findDocumentsMetadata({ documentIdentity });
        dispatch(setColumnsInDocumentGridWithAdditionalInfoBeingLoaded([]));
        saveExtendedInfo(resp);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rows, getExtendedColumns, saveExtendedInfo],
  );

  return { loadExtendedInfo };
};
